export const NEW_MCI_STRING = '_CREATE_MCI_ID';
export const UNCLEARED_CLIENT_STRING = '_CREATE_UNCLEARED_CLIENT';
